export default "__VITE_ASSET__eI6tWN8i__"